import React from "react"

import { AppCrudTable } from "@components"
import { userSettingAcrissData } from "../../../@signals"
import { actionsColumn, colorColumn, nameColumn } from "./columns"
import { isTourDemoActive } from "@signals/app"

export default function UserSettingsAcrissTable() {
	if (isTourDemoActive.value && !userSettingAcrissData.value?.length) return null
    return <AppCrudTable
		title="Your ACRISS Colors"
		data={userSettingAcrissData.value}
		columns={[
			nameColumn(),
			colorColumn(),
			actionsColumn()
		]}
	/>
}